
















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Enterprise } from '@/models/admin/enterprise';
import { Tenant } from '@/models/admin/tenant';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import {enterpriseService,tenantService,userService} from '@/shared';

@Component({})
export default class ImpersonateLoginPage extends Base {
    public enterprises: Enterprise[] = [];
    public requestProgress: boolean = false;
    public tenants: Tenant[] = [];
    public users: any[] = [];
    public tenantId: number;
    public enterpriseId: number;
    public userGuidId: string = '';
    public form: any = {};
    public formFields: Array<VFields<any>> = [];
    public model: any = {};
    public created(): void {
        this.setFields();
    }
    public mounted() {
        this.getTenants();
    }
    public setFields(): void {
        this.formFields = [
            {
                key: 'tenantId',
                type: 'v-alynk-select',
                required: true,
                templateOptions: {
                    label: this.$parent.$t('impersonateLogin.lblTenant') as string,
                    multiple: false,
                    validations: 'required',
                    required: true,
                    items: this.tenants,
                    text: 'name',
                    value: 'id',
                    disabled: false,
                    loading: false,
                    events: {
                        onChange: (items, value) => {
                            this.tenantId = value;
                            this.GetEnterpriseIdTenatId(value);
                        },
                    },
                },
            },
            {
                key: 'enterpriseId',
                type: 'v-alynk-select',
                required: true,
                templateOptions: {
                    counter: 50,
                    label: this.$parent.$t('impersonateLogin.lblEnterprise') as string,
                    validations: 'required',
                    items: this.enterprises,
                    text: 'name',
                    value: 'id',
                    required: true,
                    disabled: false,
                    loading: false,
                    events: {
                        onChange: (items, value) => {
                            this.enterpriseId = value;
                            this.GetUsers(this.tenantId, value);
                        },
                    },
                },
            },
            {
                key: 'userId',
                type: 'v-alynk-select',
                required: true,
                templateOptions: {
                    counter: 50,
                    label: this.$parent.$t('impersonateLogin.lblUsers') as string,
                    validations: 'required',
                    items: this.users,
                    text: 'email',
                    value: 'userId',
                    required: true,
                    disabled: false,
                    loading: false,
                    events: {
                        onChange: (items, value) => {
                            this.userGuidId = value;
                        },
                    },
                },
            },
        ];
    }
    public async GetEnterpriseIdTenatId(tenantId: number): Promise<void> {
        try {
            this.formlyShowSkeleton(this.formFields, 'enterpriseId');
            const enterprises = await enterpriseService.getEnterprisebyTenant(
                tenantId,
            );
            this.setFormlyItems('enterpriseId', enterprises);
        } finally {
            this.formlyHideSkeleton(this.formFields, 'enterpriseId');
        }
    }

    public setFormlyItems(fieldname: string, value: any[]) {
        const field = this.formFields.find((m) => {
            return m.key === fieldname;
        });
        if (field) {
            field.templateOptions.items = value;
        }
    }

    public async GetUsers(tenantId: number, enterpriseId: number) {
        try {
            if ((tenantId && enterpriseId) > 0) {
                this.formlyShowSkeleton(this.formFields, 'userId');
                const enterpriseUsers = await userService.getAllEnterpriseUser(tenantId, enterpriseId);
                this.setFormlyItems('userId', enterpriseUsers);
            }
            this.users = [];
        } finally {
            this.formlyHideSkeleton(this.formFields, 'userId');
        }
    }

    public async switchUserProfile(): Promise<void> {
        try {
            this.requestProgress = true;
            const userSessionResponse = await userService.
                switchUser(this.tenantId, this.enterpriseId, this.userGuidId);
            const user = await userService.getCurrentUserInfoAsync();
            this.$store.dispatch('setUserDisplayName', user.displayName);
            this.$store.dispatch('setUserEmail', user.email);
            this.$store.dispatch('setUserId', user.userId);
            this.redirectToSelectStore();
        } finally {
            this.requestProgress = false;
        }
    }

    public redirectToSelectStore(): void {
        if (this.$route.query && this.$route.query.redirectUrl) {
            const url = this.$route.query.redirectUrl;
            this.$router.push({ path: '/app/store/select', query: { redirectUrl: url } });
        } else {
            this.$router.push({ name: 'app.store.select' });
        }
    }

    public async getTenants(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.formFields, 'tenantId');
            const tenants = await tenantService.getAllAsync();
            this.setFormlyItems('tenantId', tenants.results);
        } finally {
            this.formlyHideSkeleton(this.formFields, 'tenantId');
        }
    }
}
